import {
  getFirstTodo,
  getGoldSetReviewUrl,
  GoldSetProgress,
  useGoldSetPass,
  useGoldSetQueue,
} from '~/entities/gold-set'
import { getApiErrorStatus } from '~/shared/lib/api-error'
import {
  Alert,
  Button,
  DataTableLoadingSkeleton,
  Segment,
  SegmentedButton,
  SkeletonBlock,
  Text,
} from '~/shared/ui'
import { BlindReviewReminder } from './blind-review-reminder'
import { QueueTable } from './queue-table'

export function GoldSetQueuePage() {
  const [pass, setPass] = useGoldSetPass()
  const { data: queue, error, isPending, isError, refetch } = useGoldSetQueue(pass)
  const firstTodo = queue ? getFirstTodo(queue.items) : undefined
  const errorStatus = getApiErrorStatus(error)

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <header className="border-divider flex shrink-0 flex-col gap-4 border-b px-6 py-4">
        <div className="flex flex-wrap items-center justify-between gap-6">
          <div className="flex flex-col">
            <Text appearance="H6">Gold set review</Text>
            <Text
              className="text-text-secondary"
              appearance="BODY2"
            >
              {`Pass ${pass}`}
            </Text>
          </div>
          {queue ? (
            <GoldSetProgress queue={queue} />
          ) : (
            isPending && <SkeletonBlock className="h-9 w-[220px]" />
          )}
          <div className="flex flex-wrap items-center gap-4">
            {queue && queue.passes.length > 1 && (
              <SegmentedButton size="small">
                {queue.passes.map((passNumber) => (
                  <Segment
                    key={passNumber}
                    checked={passNumber === pass}
                    onClick={() => setPass(passNumber)}
                  >
                    {`Pass ${passNumber}`}
                  </Segment>
                ))}
              </SegmentedButton>
            )}
            {firstTodo && (
              <Button
                raised
                to={getGoldSetReviewUrl(firstTodo.short_key, pass)}
              >
                Continue reviewing
              </Button>
            )}
          </div>
        </div>
        <BlindReviewReminder />
        {queue && queue.items.length > 0 && !firstTodo && (
          <Alert
            className="grow-0"
            appearance="SUCCESS"
            materialIcon="check_circle"
          >
            All done: every document in this pass has a label.
          </Alert>
        )}
      </header>
      <div className="flex-1 overflow-hidden">
        {isPending ? (
          <DataTableLoadingSkeleton
            columnsCount={3}
            rowsCount={10}
            withStickyHeader
          />
        ) : isError ? (
          <div className="flex flex-col items-start gap-3 p-6">
            <Alert
              className="grow-0"
              appearance="ERROR"
              materialIcon="error"
            >
              {errorStatus === 403
                ? 'The gold set review is not available for your account.'
                : 'Could not load the gold set queue.'}
            </Alert>
            {errorStatus !== 403 && <Button onClick={() => refetch()}>Try again</Button>}
          </div>
        ) : (
          <QueueTable
            items={queue.items}
            pass={pass}
          />
        )}
      </div>
    </div>
  )
}
